import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'vi', 'zh', 'zh-Hant'],
    nonExplicitSupportedLngs: true,
    load: 'currentOnly',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lam-lang',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => {
        if (lng.toLowerCase().startsWith('zh')) {
          if (/hant|tw|hk|mo/i.test(lng)) return 'zh-Hant';
          return 'zh';
        }
        return lng;
      },
    },
  });

export default i18n;